import type { ButtonProps } from '../Button.types';

type GetIsSpinThemeInverted = Required<Pick<ButtonProps, 'view'>> & Pick<ButtonProps, 'checked'>;

const checkedBrightViews: Set<string> = new Set(['secondary', 'outline', 'contrast', 'media']);
const brightViews: Set<string> = new Set(['primary']);

export const getIsSpinThemeInverted = (props: GetIsSpinThemeInverted): boolean => {
    const { checked, view } = props;

    return checked ? checkedBrightViews.has(view) : brightViews.has(view);
};
